'use strict';

(function () {
  'use strict';

  angular.module('vnext').directive('msAlerts', msAlerts);

  msAlerts.$inject = [];

  function msAlerts() {
    var directive = {
      templateUrl: 'vnext/templates/alerts.html',
      controller: ['$timeout', 'NotifyingSvc', 'alertSvc', AlertsCtrl],
      controllerAs: 'messageVm',
      restrict: 'AE',
      scope: {}
    };
    return directive;
  }

  function AlertsCtrl($timeout, NotifyingSvc, alertSvc) {
    var vm = this;
    NotifyingSvc.subscribe(NotifyingSvc.EVENTS.ALERTS_UPDATED, function () {
      $timeout(function () {
        vm.messages = alertSvc.getAlerts();
      });
    });
    vm.messages = alertSvc.getAlerts();
  }
})();